enum VideoStrategy {
  PreferStream = 'PreferStream',
  Stable = 'Stable'
}
export default VideoStrategy
